import orderBy from 'lodash/orderBy';

export const clients = ({ items }) => orderBy(items, ['id'], ['desc'])
